import React from 'react';
import PropTypes from 'prop-types';
import {FEEDBACK_ICON_PATHS} from '../../constants/constants';

// The feedback modal's icons. They draw in currentColor, so each takes the
// colour of the button it sits in.

export const StarIcon = ({filled}) => (
  <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d={FEEDBACK_ICON_PATHS.STAR}
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
);

StarIcon.propTypes = {
  filled: PropTypes.bool,
};

StarIcon.defaultProps = {
  filled: false,
};

export const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d={FEEDBACK_ICON_PATHS.CLOSE}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const CommentIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d={FEEDBACK_ICON_PATHS.COMMENT}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

export const TickIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d={FEEDBACK_ICON_PATHS.TICK}
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
